import SqFetch from 'application/fetch';
import { createVerificationDetails } from './web_payment_sdk';
import { CARD_INTENT } from 'constants/enums';
import { trackCdp } from 'utilities/tracking';

const createPaymentData = (tokenResult) => {
  if (tokenResult.details?.cashAppPay?.cashtag) {
    return { cashtag: tokenResult.details.cashAppPay.cashtag };
  } else {
    const cardData = tokenResult.details.card;
    const postalCode = tokenResult.details.billing?.postalCode;
    return {
      card_data: {
        card_brand: cardData.brand,
        last_4: cardData.last4,
        exp_year: cardData.expYear,
        exp_month: cardData.expMonth,
        postalCode,
      },
    };
  }
};

const getCardIntent = (orderData, saveCardToWallet) => {
  if (saveCardToWallet) {
    return CARD_INTENT.CHARGE_AND_STORE;
  }
  return orderData.card_intent?.intent?.toUpperCase() || CARD_INTENT.CHARGE;
};

const createShopPaymentWithSavedCard = (
  orderNumber,
  orderData,
  selectedCard,
) => {
  const requestParams = {
    order_number: orderNumber,
    wallet_payment_source_id: selectedCard.id,
    forter_token: window.ftrToken,
    save_to_wallet: false,
    card_data: {
      card_brand: selectedCard.payment_source.brand,
      last_4: selectedCard.payment_source.last_digits,
      exp_year: selectedCard.payment_source.year,
      exp_month: selectedCard.payment_source.month,
      postalCode: selectedCard.payment_source?.address?.postal_code || '',
    },
  };

  return SqFetch.post('../../api/v1/payments', requestParams);
};

const createShopPaymentWithToken = async (
  orderNumber,
  orderData,
  tokenResult,
  sqPayments,
  issuerInstallmentsTerm = null,
  saveCardToWallet = false,
) => {
  const cardIntent = getCardIntent(orderData, saveCardToWallet);

  try {
    const scaResponse = await sqPayments.verifyBuyer(
      tokenResult.token,
      createVerificationDetails(orderData, cardIntent),
    );

    trackCdp({
      name: 'verifyBuyer response',
      params: {
        feature: 'shop',
        order_number: orderNumber,
        user_challenged: scaResponse.userChallenged,
        save_card_to_wallet: saveCardToWallet,
        token: scaResponse.token,
      },
    });

    const requestParams = {
      order_number: orderNumber,
      nonce: tokenResult.token,
      verification_token: scaResponse.token, // buyer verification token
      forter_token: window.ftrToken,
      issuer_number_of_installments: issuerInstallmentsTerm,
      save_to_wallet: saveCardToWallet,
      wallet_payment_source_id: null,
      ...createPaymentData(tokenResult),
    };

    return SqFetch.post('../../api/v1/payments', requestParams);
  } catch (e) {
    trackCdp({
      name: 'verifyBuyer error',
      params: {
        feature: 'shop',
        order_number: orderNumber,
        error_message: e.message,
        error_name: e.name,
        error_stack: e.stack,
      },
    });
    throw e;
  }
};

const checkPreAuthFraud = (orderNumber, tokenResult) => {
  try {
    const requestParams = {
      order_number: orderNumber,
      nonce: tokenResult.token,
      forter_token: window.ftrToken,
      ...createPaymentData(tokenResult),
    };
    return SqFetch.post('../../api/v1/pre-auth', requestParams);
  } catch {
    return null;
  }
};

export {
  createShopPaymentWithToken,
  createShopPaymentWithSavedCard,
  checkPreAuthFraud,
};
